<template>
  <div class="">
    <img class="errorPic" src="/static/images/maintain.png"  alt="">
    <div class="text-cent">
      <p class="text-left col-999" style="text-align: center;">当前系统繁忙，请客官稍候再试</p>
      <div class="btnback theme-bg" @click="gohome">
        返回首页
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "error",
    data () {
      return {
        datas:'',
      }
    },
    created(){
    },
    methods: {

      goback:function () {
        history.go(-1)
      },
      gohome:function () {
        this.$router.push({path:'/'})
      },
    },
    mounted () {
    },
  }
</script>

<style lang="less" scoped>
.errorPic{
    width: 70%;
    margin-left: 15%;
    margin-top: 25%;
    margin-bottom: 5%;
  }
  p{
    padding: 0px 45px;
    margin-top: 3px;
  }
  .sorrryAbout{
    margin-top: 40px;
    margin-bottom: 10px;
    padding: 0px 15px;
    i{
      vertical-align: middle;
      font-size: 20px;
      margin-right: 10px;
      position: relative;
      top:-1px;
    }
  }
  .van-button {
    height: 40px;
    line-height: 38px;
  }
  .btnback{
    width: 120px;;
    text-align: center;
    margin: auto;
    margin-top: 15px;
    line-height: 30px;
    border-radius: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/activity/overtime.vue